import Breadcrumbs from "@/components/entities/breadcrumbs";
import HeaderBackground from "@/components/ui/header-background";
import { useTranslations } from "next-intl";
import ProductCardLoading from "@/components/entities/product-card/loading-card";
import Skeleton from "react-loading-skeleton";
import { Container } from "@/components/ui/container";
import S from "./index.module.scss";

export const FavoritesLoading = () => {
  const t = useTranslations();

  const breadcrumbs = [{ title: t("home"), url: "/" }];

  return (
    <>
      <HeaderBackground type="black" />
      <Container>
        <div className={S.headerWrapper}>
          <Breadcrumbs breadcrumbs={breadcrumbs} />
          <div className={S.headerInfo}>
            <h1 className={S.title}>
              <Skeleton width={200} />
            </h1>
            <p className={S.counter}>
              <Skeleton width={100} />
            </p>
          </div>
        </div>
      </Container>
      <Container>
        <div className={S.gridWrapper}>
          <div className={S.favoritesGrid}>
            {new Array(3).fill({ id: 0 }).map((_, idx) => (
              <ProductCardLoading key={idx} />
            ))}
          </div>
        </div>
      </Container>
    </>
  );
};

export default FavoritesLoading;
